import termsAndConditions from './termsAndConditions';
export default termsAndConditions;
